@if (isVisible) {
  <button
    class="scroll-to-top-button"
    (click)="scrollToTop()">
    <i class="bi bi-arrow-up"></i>
  </button>
}

<!-- [ngClass]="{'visible': isVisible}" -->
